import { createColumnHelper } from "@tanstack/react-table";
import { IconButton, Stack } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useLocation, useParams } from "react-router-dom";
import { useEJOESRApprovalContext } from "../../Context/EJOESRApprovalContext";
import { ESREquipmentServiceColumns } from "../ESR-EquipmentService/utils/types";
import { useESRApprovalContext } from "../../Context/ESRApprovalContext";

export const useCreateESREquipmentServicesColumns = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const {
    setCurrentESSelected,
    setOpenESDialog,
    setESActionType,
    setOpenESDeleteDialog,
  } = useESRApprovalContext();

  const columnHelper = createColumnHelper<ESREquipmentServiceColumns>();

  const esrEquipmentServicesColumns = [
    columnHelper.accessor("id", {
      header: "",
      cell: () => null,
      meta: {
        hidden: true,
      },
    }),
    columnHelper.accessor("taskTypeItem", {
      id: "taskTypeItem",
      header: "Task Type",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("taskItem", {
      id: "taskItem",
      header: "Item",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: false,
    }),
    columnHelper.accessor("partNumber", {
      id: "partNumber",
      header: "Part No.",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("quantity", {
      id: "quantity",
      header: "Quantity",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),

    columnHelper.accessor("remarks", {
      id: "remarks",
      header: "Remarks",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    ...(pathSegments[2] == "create" ||
    pathSegments[2] == "edit" ||
    pathSegments[2] == "start" ||
    pathSegments[2] == "complete"
      ? [
          columnHelper.display({
            id: "actions",
            header: "Action",
            cell: ({ row }) => (
              <Stack direction="row" gap="2">
                <IconButton
                  color="primary"
                  onClick={() => {
                    const tempId = String(row.index);
                    setCurrentESSelected({
                      id: row.original.id ? row.original.id : tempId,
                      taskItem: row.original.taskItem,
                      taskTypeId: row.original.taskTypeId,
                      taskTypeItem: row.original.taskTypeItem,
                      partNumber: row.original.partNumber,
                      quantity: row.original.quantity,
                      remarks: row.original.remarks,
                    });
                    setOpenESDialog(true);
                    setESActionType("update");
                  }}
                >
                  <EditIcon fontSize="medium" />
                </IconButton>

                <IconButton
                  color="primary"
                  onClick={() => {
                    const tempId = String(row.index);
                    setCurrentESSelected({
                      id: tempId,
                      taskItem: row.original.taskItem,
                      taskTypeId: row.original.taskTypeId,
                      taskTypeItem: row.original.taskTypeItem,
                      partNumber: row.original.partNumber,
                      quantity: row.original.quantity,
                      remarks: row.original.remarks,
                    });
                    setOpenESDeleteDialog(true);
                  }}
                >
                  <DeleteIcon fontSize="medium" />
                </IconButton>
              </Stack>
            ),
            enableHiding: false,
          }),
        ]
      : []),
  ];

  return esrEquipmentServicesColumns;
};
